/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../buttons/icon-button/icon-button.component.ngfactory';
import * as import2 from '../buttons/icon-button/icon-button.component';
import * as import3 from '../order/order-summary-icon/order-summary-icon.component.ngfactory';
import * as import4 from '../order/order-summary-icon/order-summary-icon.component';
import * as import5 from '../order/order.model';
import * as import6 from '../notification/message/message.component.ngfactory';
import * as import7 from '../notification/message/message.component';
import * as import8 from '../notification/notification.service';
import * as import9 from '../buttons/link/link.component.ngfactory';
import * as import10 from '../buttons/link/link.component';
import * as import11 from '../ordering-context/ordering-context-panel/ordering-context-panel.component.ngfactory';
import * as import12 from '../ordering-context/ordering-context-panel/ordering-context-panel.component';
import * as import13 from '../ordering-context/ordering-context.model';
import * as import14 from '../orchestration/responsive.service';
import * as import15 from '../orchestration/navigation.service';
import * as import16 from '../promo/promo-carousel/promo-carousel.component.ngfactory';
import * as import17 from '../promo/promo-carousel/promo-carousel.component';
import * as import18 from '../orchestration/session.model';
import * as import19 from '../identity/identity.model';
import * as import20 from '../orchestration/analytics.service';
import * as import21 from '../page-layout/page-header-image/page-header-image.component.ngfactory';
import * as import22 from '../page-layout/page-header-image/page-header-image.component';
import * as import23 from './order-heading-panel/order-heading-panel.component.ngfactory';
import * as import24 from './order-heading-panel/order-heading-panel.component';
import * as import25 from './feature-button-panel/feature-button-panel.component.ngfactory';
import * as import26 from '@angular/common';
import * as import27 from './feature-button-panel/feature-button-panel.component';
import * as import28 from '../group-order/group-order.model';
import * as import29 from '../deal/deal.model';
import * as import30 from '../menu/menu-category-selection-panel/menu-category-selection-panel.component.ngfactory';
import * as import31 from '../menu/menu-category-selection-panel/menu-category-selection-panel.component';
import * as import32 from '../menu/menu.model';
import * as import33 from '../menu/menu-subcategory-anchor-panel/menu-subcategory-anchor-panel.component.ngfactory';
import * as import34 from '../menu/menu-subcategory-anchor-panel/menu-subcategory-anchor-panel.component';
import * as import35 from '../menu/menu-item-selection-panel/menu-item-selection-panel.component.ngfactory';
import * as import36 from '../menu/menu-item-selection-panel/menu-item-selection-panel.component';
import * as import37 from '../ui-elements/chewzie-logo/chewzie-logo.component.ngfactory';
import * as import38 from '../ui-elements/chewzie-logo/chewzie-logo.component';
import * as import39 from '../order/order-edit-panel/order-edit-panel.component.ngfactory';
import * as import40 from '../order/order-edit-panel/order-edit-panel.component';
import * as import41 from '../group-order/group-order-summary-icon/group-order-summary-icon.component.ngfactory';
import * as import42 from '../group-order/group-order-summary-icon/group-order-summary-icon.component';
import * as import43 from '../inputs/selector-control/selector-control.component.ngfactory';
import * as import44 from '../inputs/selector-control/selector-control.component';
import * as import45 from '../order/order-totals-panel/order-totals-panel.component.ngfactory';
import * as import46 from '../order/order-totals-panel/order-totals-panel.component';
import * as import47 from '../buttons/button/button.component.ngfactory';
import * as import48 from '../buttons/button/button.component';
import * as import49 from '../page-layout/page-footer-control.directive';
import * as import50 from '../payment/quick-pay-panel/quick-pay-panel.component.ngfactory';
import * as import51 from '../payment/quick-pay-panel/quick-pay-panel.component';
import * as import52 from '../payment/payment.model';
import * as import53 from '../legal/legal-panel/legal-panel.component.ngfactory';
import * as import54 from '../legal/legal-panel/legal-panel.component';
import * as import55 from '../page-layout/full-page-layout/full-page-layout.component.ngfactory';
import * as import56 from '../page-layout/full-page-layout/full-page-layout.component';
import * as import57 from '../orchestration/page';
import * as import58 from '../theme/theme.model';
import * as import59 from '../order/order-errors-panel/order-errors-panel.component.ngfactory';
import * as import60 from '../order/order-errors-panel/order-errors-panel.component';
import * as import61 from '../orchestration/responsive.directive';
import * as import62 from '../page-layout/desktop-home-page-layout/desktop-home-page-layout.component.ngfactory';
import * as import63 from '../ui-elements/image/background-image.directive';
import * as import64 from '../ui-elements/image/cached-image.service';
import * as import65 from '../page-layout/desktop-home-page-layout/desktop-home-page-layout.component';
import * as import66 from './ordering-page.component';
import * as import67 from '../ui-elements/loading/loading.service';
import * as import68 from '@fedelta-pos/data-client/auth/auth.service';
import * as import69 from '../schedule/active-schedules-search.model';
import * as import70 from '../promo/promo.model';
const styles_OrderingPageComponent:any[] = ([] as any[]);
export const RenderType_OrderingPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderingPageComponent,
  data: {}
}
);
function View_OrderingPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'slot',
        'navbar-left'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.navigationService.createPage('woa-nav-menu-page',(undefined as any),{alignment: co.PageAlignment.LEFT})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.MENU;
    const currVal_4:boolean = !co.isLoaded;
    ck(v,1,0,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_OrderingPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-summary-icon',[[
        'slot',
        'navbar-right'
      ]
      ],(null as any),[[
        (null as any),
        'onOrderSummary'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOrderSummary' === en)) {
        const pd_0:any = ((<any>co.viewOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_OrderSummaryIconComponent_0,import3.RenderType_OrderSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import4.OrderSummaryIconComponent,[
      import5.OrderModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),{onOrderSummary: 'onOrderSummary'})
  ]
  ,(null as any),(null as any));
}
function View_OrderingPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_ContentMessageComponent_0,import6.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.ContentMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,5,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.requestReload('failure reload',true,true,false,true)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_LinkComponent_0,import9.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        5,
        4
      ]
      ],0,import10.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = 'woa.error.common.loadFailed';
    ck(v,1,0,currVal_8,currVal_9);
    const currVal_10:any = 'woa.button.order.reload';
    ck(v,5,0,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_ContentMessageComponent_0,import6.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.ContentMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,6,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderModel.requestOrderInitiation('ordering page - initiation error retry')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_LinkComponent_0,import9.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        6,
        4
      ]
      ],0,import10.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.orderModel.initiationErrorKey;
    const currVal_10:any = co.orderModel.initiationErrorParams;
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
    const currVal_11:any = 'woa.button.common.retry';
    ck(v,5,0,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-ordering-context-panel',[[
        'class',
        'mobile-page-ordering-context'
      ]
    ],(null as any),(null as any),(null as any),import11.View_OrderingContextPanelComponent_0,import11.RenderType_OrderingContextPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import12.OrderingContextPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import14.ResponsiveService,
      import15.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-carousel',[[
        'class',
        'mobile-page-promo-carousel'
      ]
    ],(null as any),[
      [
        (null as any),
        'onOrderDeal'
      ]
      ,
      [
        (null as any),
        'onPromoActioned'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOrderDeal' === en)) {
        const pd_0:any = ((<any>co.orderDeal($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onPromoActioned' === en)) {
        const pd_1:any = ((<any>co.promoActioned($event.promo,$event.promo.promoCardAction,$event.menuItem)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import16.View_PromoCarouselComponent_0,import16.RenderType_PromoCarouselComponent)),
    import0.ɵdid(770048,(null as any),0,import17.PromoCarouselComponent,[
      import18.SessionModel,
      import19.IdentityModel,
      import20.AnalyticsService,
      import15.NavigationService,
      import0.ElementRef,
      import0.ChangeDetectorRef
    ]
    ,{
      promoteMemberLogin: [
        0,
        'promoteMemberLogin'
      ]
      ,
      deals: [
        1,
        'deals'
      ]
      ,
      promos: [
        2,
        'promos'
      ]
      ,
      morePromotionalCards: [
        3,
        'morePromotionalCards'
      ]
      ,
      showMorePromotionalCardsAsSlide: [
        4,
        'showMorePromotionalCardsAsSlide'
      ]
      ,
      nrVisibleSlides: [
        5,
        'nrVisibleSlides'
      ]
      ,
      autoScrollEnabled: [
        6,
        'autoScrollEnabled'
      ]

    }
    ,{
      onOrderDeal: 'onOrderDeal',
      onPromoActioned: 'onPromoActioned'
    }
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = true;
    const currVal_1:any = co.promotedDeals;
    const currVal_2:any = (co.orderModel.personalOrderStarted? co.triggeredAndUnsuppressedCardPromos: co.promotedCardPromos);
    const currVal_3:any = (co.orderModel.personalOrderStarted? false: co.morePromotionalCards);
    const currVal_4:any = true;
    const currVal_5:any = co.nrVisibleSlides;
    const currVal_6:boolean = !co.sessionModel.noAutoScroll;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  },(null as any));
}
function View_OrderingPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-page-header-image',[[
        'class',
        'mobile-page-store-image'
      ]
    ],(null as any),(null as any),(null as any),import21.View_PageHeaderImageComponent_0,import21.RenderType_PageHeaderImageComponent)),
    import0.ɵdid(245760,(null as any),0,import22.PageHeaderImageComponent,[
      import18.SessionModel,
      import13.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-heading-panel',[[
        'class',
        'mobile-page-order-heading'
      ]
    ],(null as any),(null as any),(null as any),import23.View_OrderHeadingPanelComponent_0,import23.RenderType_OrderHeadingPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import24.OrderHeadingPanelComponent,[
      import13.OrderingContextModel,
      import15.NavigationService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
function View_OrderingPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-feature-button-panel',[[
        'class',
        'mobile-page-feature-buttons'
      ]
      ],(null as any),[[
        (null as any),
        'onOpenGroupOrder'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOpenGroupOrder' === en)) {
        const pd_0:any = ((<any>co.groupOrderModel.openGroupOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import25.View_FeatureButtonPanelComponent_0,import25.RenderType_FeatureButtonPanelComponent)),
    import0.ɵdid(278528,(null as any),0,import26.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['order-view']),
    import0.ɵdid(245760,(null as any),0,import27.FeatureButtonPanelComponent,[
      import18.SessionModel,
      import13.OrderingContextModel,
      import19.IdentityModel,
      import28.GroupOrderModel,
      import29.DealModel,
      import15.NavigationService,
      import0.ChangeDetectorRef,
      import20.AnalyticsService
    ]
    ,(null as any),{onOpenGroupOrder: 'onOpenGroupOrder'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'mobile-page-feature-buttons';
    const currVal_1:any = ck(v,3,0,import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform(co.viewingOrder$)));
    ck(v,1,0,currVal_0,currVal_1);
    ck(v,4,0);
  },(null as any));
}
function View_OrderingPageComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-category-selection-panel',[[
        'class',
        'mobile-page-menu-categories'
      ]
      ],[[
        2,
        'with-images',
        (null as any)
      ]
    ],(null as any),(null as any),import30.View_MenuCategorySelectionPanelComponent_0,import30.RenderType_MenuCategorySelectionPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import31.MenuCategorySelectionPanelComponent,[
      import32.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).withImages;
    ck(v,0,0,currVal_0);
  });
}
function View_OrderingPageComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        2,
        0
      ]
      ],(null as any),1,'woa-menu-subcategory-anchor-panel',[[
        'class',
        'mobile-page-menu-subcategory-anchors'
      ]
    ],(null as any),(null as any),(null as any),import33.View_MenuSubcategoryAnchorPanelComponent_0,import33.RenderType_MenuSubcategoryAnchorPanelComponent)),
      import0.ɵdid(4440064,[[
        'anchorPanel',
        4
      ]
    ],0,import34.MenuSubcategoryAnchorPanelComponent,[
      import32.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-item-selection-panel',[[
        'class',
        'mobile-page-menu-items'
      ]
      ],(null as any),[[
        (null as any),
        'onBack'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onBack' === en)) {
        const pd_0:any = ((<any>co.navigationService.dismissView()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import35.View_MenuItemSelectionPanelComponent_0,import35.RenderType_MenuItemSelectionPanelComponent)),
    import0.ɵdid(4440064,(null as any),0,import36.MenuItemSelectionPanelComponent,[
      import32.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,{
      pageScroller: [
        0,
        'pageScroller'
      ]
      ,
      anchorPanel: [
        1,
        'anchorPanel'
      ]

    }
    ,{onBack: 'onBack'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.pageLayout == null)? (null as any): co.pageLayout.scrollerElementRef);
    const currVal_1:any = co.anchorPanelER;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderingPageComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingPageComponent_13)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingPageComponent_14)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingPageComponent_15)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = !import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform(co.viewingMenuItems$));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.viewingMenuItems$));
    ck(v,7,0,currVal_1);
    const currVal_2:any = import0.ɵunv(v,11,0,import0.ɵnov(v,12).transform(co.viewingMenuItems$));
    ck(v,11,0,currVal_2);
  },(null as any));
}
function View_OrderingPageComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_ContentMessageComponent_0,import6.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.ContentMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,7,{links: 1})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.INFO;
    const currVal_9:any = co.StringUtils.quote(co.sessionModel.currentApp.dietaryStatement);
    ck(v,1,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingPageComponent_12)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'mobile-page-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingPageComponent_16)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'mobile-page-footer-logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-chewzie-logo',([] as any[]),(null as any),(null as any),(null as any),import37.View_ChewzieLogoComponent_0,import37.RenderType_ChewzieLogoComponent)),
    import0.ɵdid(49152,(null as any),0,import38.ChewzieLogoComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showMenu;
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.isLoaded && co.sessionModel.currentApp.dietaryStatement);
    ck(v,8,0,currVal_1);
  },(null as any));
}
function View_OrderingPageComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-edit-panel',[[
        'class',
        'mobile-page-order'
      ]
    ],(null as any),[
      [
        (null as any),
        'onEditOrderItem'
      ]
      ,
      [
        (null as any),
        'onRemoveOrderItem'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onEditOrderItem' === en)) {
        const pd_0:any = ((<any>co.orderModel.editOrderItem($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onRemoveOrderItem' === en)) {
        const pd_1:any = ((<any>co.orderModel.removeOrderItem($event)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import39.View_OrderEditPanelComponent_0,import39.RenderType_OrderEditPanelComponent)),
    import0.ɵdid(4374528,(null as any),0,import40.OrderEditPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import32.MenuModel,
      import15.NavigationService,
      import0.ChangeDetectorRef,
      import8.NotificationService,
      import20.AnalyticsService
    ]
      ,{showRetry: [
        0,
        'showRetry'
      ]
    },{
      onEditOrderItem: 'onEditOrderItem',
      onRemoveOrderItem: 'onRemoveOrderItem'
    }
    )
  ]
  ,(ck,v) => {
    const currVal_0:any = false;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingPageComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-footer-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_FooterMessageComponent_0,import6.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.FooterMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      icon: [
        1,
        'icon'
      ]
      ,
      text: [
        2,
        'text'
      ]
      ,
      translationParams: [
        3,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,8,{links: 1}),
    import0.ɵpod([
      'category',
      'venueWaitTime',
      'categoryWaitTime'
    ]
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.WARNING;
    const currVal_9:any = 'clock-three';
    const currVal_10:any = co.waitTimeNotice;
    const currVal_11:any = ck(v,3,0,co.menuModel.getCategoryDisplayName(co.menuModel.selectedCategory),co.orderingContextModel.venueWaitTime,co.menuModel.selectedCategoryWaitTime);
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-footer-message',[[
        'class',
        'group-order-notice'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.groupOrderModel.openGroupOrder()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_FooterMessageComponent_0,import6.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.FooterMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      showIcon: [
        2,
        'showIcon'
      ]
      ,
      actionable: [
        3,
        'actionable'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,9,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'woa-group-order-summary-icon',([] as any[]),(null as any),(null as any),(null as any),import41.View_GroupOrderSummaryIconComponent_0,import41.RenderType_GroupOrderSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import42.GroupOrderSummaryIconComponent,[
      import5.OrderModel,
      import28.GroupOrderModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.SUCCESS;
    const currVal_9:any = 'woa.message.order.groupOrderNotice';
    const currVal_10:any = false;
    const currVal_11:any = true;
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-selector-control',[
      [
        'class',
        'marketing-opt-in'
      ]
      ,
      [
        'slot',
        'footer-start'
      ]

    ]
    ,[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'touched',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.orderingContextModel.marketingOptIn = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import43.View_SelectorControlComponent_0,import43.RenderType_SelectorControlComponent)),
    import0.ɵdid(49152,(null as any),0,import44.SelectorControlComponent,([] as any[]),{
      selected: [
        0,
        'selected'
      ]
      ,
      label: [
        1,
        'label'
      ]

    }
    ,{selectedChange: 'selectedChange'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.orderingContextModel.marketingOptIn;
    const currVal_3:any = 'woa.label.common.marketingOptIn';
    ck(v,1,0,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).touched;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_OrderingPageComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-totals-panel',[
      [
        'class',
        'totals'
      ]
      ,
      [
        'slot',
        'footer-start'
      ]

    ]
    ,(null as any),(null as any),(null as any),import45.View_OrderTotalsPanelComponent_0,import45.RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import46.OrderTotalsPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import15.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
function View_OrderingPageComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.viewOrder()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import47.View_ButtonComponent_0,import47.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import48.ButtonComponent,[
      import0.ElementRef,
      import18.SessionModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['items']),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import49.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.order.view';
    const currVal_28:any = ck(v,2,0,co.orderModel.totalItems);
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingPageComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.checkout()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import47.View_ButtonComponent_0,import47.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import48.ButtonComponent,[
      import0.ElementRef,
      import18.SessionModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      showSpinner: [
        1,
        'showSpinner'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]
      ,
      prominence: [
        3,
        'prominence'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import49.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.otherPayLabel;
    const currVal_28:any = co.checkoutPending;
    const currVal_29:any = (co.checkoutPending || (import0.ɵunv(v,1,2,import0.ɵnov(v,2).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    const currVal_30:any = co.otherPayProminence;
    ck(v,1,0,currVal_27,currVal_28,currVal_29,currVal_30);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingPageComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-quick-pay-panel',[[
        'woa-page-footer-control',
        ''
      ]
      ],(null as any),[[
        (null as any),
        'pay'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pay' === en)) {
        const pd_0:any = ((<any>co.quickPay(false,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import50.View_QuickPayPanelComponent_0,import50.RenderType_QuickPayPanelComponent)),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import49.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(49152,(null as any),0,import51.QuickPayPanelComponent,[
      import52.PaymentModel,
      import18.SessionModel,
      import28.GroupOrderModel
    ]
    ,{
      showSpinner: [
        0,
        'showSpinner'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,{pay: 'pay'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkoutPending;
    const currVal_1:any = co.checkoutPending;
    ck(v,2,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderingPageComponent_25(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-legal-panel',[
      [
        'class',
        'mobile-page-payment-legal'
      ]
      ,
      [
        'slot',
        'footer-end'
      ]

    ]
    ,(null as any),(null as any),(null as any),import53.View_LegalPanelComponent_0,import53.RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import54.LegalPanelComponent,[
      import20.AnalyticsService,
      import15.NavigationService
    ]
      ,{messageSet: [
        0,
        'messageSet'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'payment';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),86,'woa-full-page-layout',[[
        'class',
        'mobile-page'
      ]
      ],(null as any),[[
        (null as any),
        'onRefresh'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onRefresh' === en)) {
        const pd_0:any = ((<any>co.requestReload('user refresh',true,true,true,true)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import55.View_FullPageLayoutComponent_0,import55.RenderType_FullPageLayoutComponent)),
    import0.ɵdid(278528,(null as any),0,import26.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['order-view']),
    import0.ɵdid(245760,(null as any),1,import56.FullPageLayoutComponent,[
      import57.Page,
      import15.NavigationService,
      import14.ResponsiveService,
      import8.NotificationService,
      import5.OrderModel,
      import58.ThemeModel,
      import0.ChangeDetectorRef
    ]
    ,{
      showNavbarLogo: [
        0,
        'showNavbarLogo'
      ]
      ,
      hideBackButton: [
        1,
        'hideBackButton'
      ]
      ,
      enableSwipeRefresh: [
        2,
        'enableSwipeRefresh'
      ]
      ,
      showExitButton: [
        3,
        'showExitButton'
      ]
      ,
      navbarTitle: [
        4,
        'navbarTitle'
      ]
      ,
      translationParams: [
        5,
        'translationParams'
      ]
      ,
      pillarboxedOnMobile: [
        6,
        'pillarboxedOnMobile'
      ]
      ,
      showFooter: [
        7,
        'showFooter'
      ]

    }
    ,{onRefresh: 'onRefresh'}),
    import0.ɵqud(603979776,4,{footerControls: 1}),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['categoryName']),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import57.PageLayout,(null as any),[import56.FullPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-icon-button',[[
        'slot',
        'navbar-right'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.searchMenu()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      enlarged: [
        2,
        'enlarged'
      ]

    }
    ,{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),1,1,(null as any),View_OrderingPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_OrderingPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,3,(null as any),View_OrderingPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_7)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_8)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_10)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingPageComponent_11)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,2,(null as any),View_OrderingPageComponent_17)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),6,1,'woa-order-errors-panel',[[
        'slot',
        'footer-messages'
      ]
    ],(null as any),(null as any),(null as any),import59.View_OrderErrorsPanelComponent_0,import59.RenderType_OrderErrorsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import60.OrderErrorsPanelComponent,[
      import5.OrderModel,
      import13.OrderingContextModel,
      import18.SessionModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),6,1,(null as any),View_OrderingPageComponent_18)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),6,1,(null as any),View_OrderingPageComponent_19)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,2,(null as any),View_OrderingPageComponent_20)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,2,(null as any),View_OrderingPageComponent_21)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,2,(null as any),View_OrderingPageComponent_22)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,2,(null as any),View_OrderingPageComponent_23)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,2,(null as any),View_OrderingPageComponent_24)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),9,2,(null as any),View_OrderingPageComponent_25)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'mobile-page';
    const currVal_1:any = ck(v,3,0,import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform(co.viewingOrder$)));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = (import0.ɵunv(v,4,0,import0.ɵnov(v,6).transform(co.viewingOrder$)) || !import0.ɵunv(v,4,0,import0.ɵnov(v,7).transform(co.viewingMenuItems$)));
    const currVal_3:boolean = !co.viewingMobileView;
    const currVal_4:any = true;
    const currVal_5:any = co.sessionModel.showExitButton;
    const currVal_6:any = ((!import0.ɵunv(v,4,4,import0.ɵnov(v,8).transform(co.viewingOrder$)) && import0.ɵunv(v,4,4,import0.ɵnov(v,9).transform(co.viewingMenuItems$)))? 'woa.heading.item-selection.title': (undefined as any));
    const currVal_7:any = ck(v,10,0,co.menuModel.getCategoryDisplayName(co.menuModel.selectedCategory));
    const currVal_8:any = 'none';
    const currVal_9:any = co.showMobileFooter;
    ck(v,4,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_10:any = co.showMobileNavMenuIcon;
    ck(v,14,0,currVal_10);
    const currVal_14:any = co.IconButtonType.SEARCH;
    const currVal_15:boolean = !co.isLoaded;
    const currVal_16:any = true;
    ck(v,17,0,currVal_14,currVal_15,currVal_16);
    const currVal_17:any = co.showOrderSummaryIcon;
    ck(v,20,0,currVal_17);
    const currVal_18:any = (co.loadingStatus === co.LoadingStatus.FAILED);
    ck(v,23,0,currVal_18);
    const currVal_19:any = (import0.ɵunv(v,26,0,import0.ɵnov(v,27).transform(co.viewingOrder$)) && (import0.ɵunv(v,26,0,import0.ɵnov(v,28).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.FAILED));
    ck(v,26,0,currVal_19);
    const currVal_20:any = co.showOrderingContextPanel;
    ck(v,31,0,currVal_20);
    const currVal_21:any = co.showCarousel;
    ck(v,34,0,currVal_21);
    const currVal_22:any = co.showMobileHeaderImage;
    ck(v,37,0,currVal_22);
    const currVal_23:any = import0.ɵunv(v,40,0,import0.ɵnov(v,41).transform(co.viewingOrder$));
    ck(v,40,0,currVal_23);
    const currVal_24:any = co.showFeatureButtons;
    ck(v,44,0,currVal_24);
    const currVal_25:boolean = !import0.ɵunv(v,47,0,import0.ɵnov(v,48).transform(co.viewingOrder$));
    ck(v,47,0,currVal_25);
    const currVal_26:any = import0.ɵunv(v,51,0,import0.ɵnov(v,52).transform(co.viewingOrder$));
    ck(v,51,0,currVal_26);
    ck(v,55,0);
    const currVal_27:any = co.waitTimeNotice;
    ck(v,58,0,currVal_27);
    const currVal_28:any = (co.isLoaded && co.groupOrderModel.showGroupOrderNotice);
    ck(v,61,0,currVal_28);
    const currVal_29:any = ((import0.ɵunv(v,64,0,import0.ɵnov(v,65).transform(co.viewingOrder$)) && co.orderingContextModel.showMarketingOptIn) && co.paymentModel.showQuickPay());
    ck(v,64,0,currVal_29);
    const currVal_30:any = ((import0.ɵunv(v,68,0,import0.ɵnov(v,69).transform(co.viewingOrder$)) && co.isLoaded) && co.orderModel.hasOrderedItems);
    ck(v,68,0,currVal_30);
    const currVal_31:boolean = ((!import0.ɵunv(v,72,0,import0.ɵnov(v,73).transform(co.viewingOrder$)) && co.isLoaded) && co.orderModel.hasOrderedItems);
    ck(v,72,0,currVal_31);
    const currVal_32:any = import0.ɵunv(v,76,0,import0.ɵnov(v,77).transform(co.viewingOrder$));
    ck(v,76,0,currVal_32);
    const currVal_33:any = (import0.ɵunv(v,80,0,import0.ɵnov(v,81).transform(co.viewingOrder$)) && co.paymentModel.showQuickPay());
    ck(v,80,0,currVal_33);
    const currVal_34:any = (import0.ɵunv(v,84,0,import0.ɵnov(v,85).transform(co.viewingOrder$)) && co.paymentModel.showQuickPay());
    ck(v,84,0,currVal_34);
  },(ck,v) => {
    const currVal_11:any = import0.ɵnov(v,17).type;
    const currVal_12:any = import0.ɵnov(v,17).disabled;
    const currVal_13:any = import0.ɵnov(v,17).unavailable;
    ck(v,16,0,currVal_11,currVal_12,currVal_13);
  });
}
function View_OrderingPageComponent_27(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_ContentMessageComponent_0,import6.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        10,
        4
      ]
    ],1,import7.ContentMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,11,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.requestReload('failure reload',true,true,false,true)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_LinkComponent_0,import9.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        11,
        4
      ]
      ],0,import10.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = 'woa.error.common.loadFailed';
    ck(v,1,0,currVal_8,currVal_9);
    const currVal_10:any = 'woa.button.order.reload';
    ck(v,5,0,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_28(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-carousel',[
      [
        'class',
        'desktop-page-promo-carousel'
      ]
      ,
      [
        'slot',
        'content-header'
      ]

    ]
    ,(null as any),[
      [
        (null as any),
        'onOrderDeal'
      ]
      ,
      [
        (null as any),
        'onPromoActioned'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOrderDeal' === en)) {
        const pd_0:any = ((<any>co.orderDeal($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onPromoActioned' === en)) {
        const pd_1:any = ((<any>co.promoActioned($event.promo,$event.promo.promoCardAction,$event.menuItem)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import16.View_PromoCarouselComponent_0,import16.RenderType_PromoCarouselComponent)),
      import0.ɵdid(770048,[[
        'carousel',
        4
      ]
    ],0,import17.PromoCarouselComponent,[
      import18.SessionModel,
      import19.IdentityModel,
      import20.AnalyticsService,
      import15.NavigationService,
      import0.ElementRef,
      import0.ChangeDetectorRef
    ]
    ,{
      promoteMemberLogin: [
        0,
        'promoteMemberLogin'
      ]
      ,
      deals: [
        1,
        'deals'
      ]
      ,
      promos: [
        2,
        'promos'
      ]
      ,
      morePromotionalCards: [
        3,
        'morePromotionalCards'
      ]
      ,
      showMorePromotionalCardsAsSlide: [
        4,
        'showMorePromotionalCardsAsSlide'
      ]
      ,
      nrVisibleSlides: [
        5,
        'nrVisibleSlides'
      ]
      ,
      autoScrollEnabled: [
        6,
        'autoScrollEnabled'
      ]

    }
    ,{
      onOrderDeal: 'onOrderDeal',
      onPromoActioned: 'onPromoActioned'
    }
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = true;
    const currVal_1:any = co.promotedDeals;
    const currVal_2:any = (co.orderModel.personalOrderStarted? co.triggeredAndUnsuppressedCardPromos: co.promotedCardPromos);
    const currVal_3:any = (co.orderModel.personalOrderStarted? false: co.morePromotionalCards);
    const currVal_4:any = false;
    const currVal_5:any = co.nrVisibleSlides;
    const currVal_6:boolean = !co.sessionModel.noAutoScroll;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  },(null as any));
}
function View_OrderingPageComponent_29(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-menu-category-selection-panel',[
      [
        'class',
        'desktop-page-menu-categories'
      ]
      ,
      [
        'slot',
        'content-selector'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
      ,[[
        2,
        'with-images',
        (null as any)
      ]
    ],(null as any),(null as any),import30.View_MenuCategorySelectionPanelComponent_0,import30.RenderType_MenuCategorySelectionPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import31.MenuCategorySelectionPanelComponent,[
      import32.MenuModel,
      import0.ChangeDetectorRef
    ]
      ,{showNavIcons: [
        0,
        'showNavIcons'
      ]
    },(null as any)),
    import0.ɵdid(737280,(null as any),0,import61.ResponsiveDirective,[
      import0.ElementRef,
      import14.ResponsiveService,
      import15.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_1:any = false;
    ck(v,1,0,currVal_1);
    ck(v,2,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).withImages;
    ck(v,0,0,currVal_0);
  });
}
function View_OrderingPageComponent_30(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-item-selection-panel',[
      [
        'class',
        'desktop-page-menu-items'
      ]
      ,
      [
        'slot',
        'content-details-main'
      ]

    ]
    ,(null as any),(null as any),(null as any),import35.View_MenuItemSelectionPanelComponent_0,import35.RenderType_MenuItemSelectionPanelComponent)),
    import0.ɵdid(4440064,(null as any),0,import36.MenuItemSelectionPanelComponent,[
      import32.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,{
      showBackButton: [
        0,
        'showBackButton'
      ]
      ,
      showClosePromoAction: [
        1,
        'showClosePromoAction'
      ]
      ,
      alwaysShowCategoryHeader: [
        2,
        'alwaysShowCategoryHeader'
      ]
      ,
      pageScroller: [
        3,
        'pageScroller'
      ]
      ,
      anchorPanel: [
        4,
        'anchorPanel'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = false;
    const currVal_1:any = true;
    const currVal_2:any = true;
    const currVal_3:any = ((import0.ɵnov((<any>v.parent),6) == null)? (null as any): import0.ɵnov((<any>v.parent),6).scrollerER);
    const currVal_4:any = co.anchorPanelER;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_OrderingPageComponent_31(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-ordering-context-panel',[[
        'slot',
        'sidebar-header'
      ]
    ],(null as any),(null as any),(null as any),import11.View_OrderingContextPanelComponent_0,import11.RenderType_OrderingContextPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import12.OrderingContextPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import14.ResponsiveService,
      import15.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_32(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-feature-button-panel',[
      [
        'class',
        'desktop-page-feature-buttons'
      ]
      ,
      [
        'slot',
        'sidebar-body'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onOpenGroupOrder'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOpenGroupOrder' === en)) {
        const pd_0:any = ((<any>co.groupOrderModel.openGroupOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import25.View_FeatureButtonPanelComponent_0,import25.RenderType_FeatureButtonPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import27.FeatureButtonPanelComponent,[
      import18.SessionModel,
      import13.OrderingContextModel,
      import19.IdentityModel,
      import28.GroupOrderModel,
      import29.DealModel,
      import15.NavigationService,
      import0.ChangeDetectorRef,
      import20.AnalyticsService
    ]
    ,(null as any),{onOpenGroupOrder: 'onOpenGroupOrder'})
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_OrderingPageComponent_33(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-footer-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_FooterMessageComponent_0,import6.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.FooterMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      icon: [
        1,
        'icon'
      ]
      ,
      text: [
        2,
        'text'
      ]
      ,
      translationParams: [
        3,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,12,{links: 1}),
    import0.ɵpod([
      'category',
      'venueWaitTime',
      'categoryWaitTime'
    ]
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.WARNING;
    const currVal_9:any = 'clock-three';
    const currVal_10:any = co.waitTimeNotice;
    const currVal_11:any = ck(v,3,0,co.menuModel.getCategoryDisplayName(co.menuModel.selectedCategory),co.orderingContextModel.venueWaitTime,co.menuModel.selectedCategoryWaitTime);
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_34(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-footer-message',[[
        'class',
        'group-order-notice'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.groupOrderModel.openGroupOrder()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_FooterMessageComponent_0,import6.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import7.FooterMessageComponent,[
      import0.ElementRef,
      import8.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      showIcon: [
        2,
        'showIcon'
      ]
      ,
      actionable: [
        3,
        'actionable'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,13,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'woa-group-order-summary-icon',([] as any[]),(null as any),(null as any),(null as any),import41.View_GroupOrderSummaryIconComponent_0,import41.RenderType_GroupOrderSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import42.GroupOrderSummaryIconComponent,[
      import5.OrderModel,
      import28.GroupOrderModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.SUCCESS;
    const currVal_9:any = 'woa.message.order.groupOrderNotice';
    const currVal_10:any = false;
    const currVal_11:any = true;
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingPageComponent_35(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-totals-panel',[
      [
        'class',
        'totals'
      ]
      ,
      [
        'slot',
        'sidebar-footer-start'
      ]

    ]
    ,(null as any),(null as any),(null as any),import45.View_OrderTotalsPanelComponent_0,import45.RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import46.OrderTotalsPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import15.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
function View_OrderingPageComponent_36(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.checkout()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import47.View_ButtonComponent_0,import47.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import48.ButtonComponent,[
      import0.ElementRef,
      import18.SessionModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      showSpinner: [
        1,
        'showSpinner'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]
      ,
      prominence: [
        3,
        'prominence'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import26.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵdid(16384,(null as any),0,import49.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.otherPayLabel;
    const currVal_28:any = co.checkoutPending;
    const currVal_29:any = (co.checkoutPending || (import0.ɵunv(v,1,2,import0.ɵnov(v,2).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    const currVal_30:any = co.otherPayProminence;
    ck(v,1,0,currVal_27,currVal_28,currVal_29,currVal_30);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingPageComponent_37(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-quick-pay-panel',[[
        'woa-page-footer-control',
        ''
      ]
      ],(null as any),[[
        (null as any),
        'pay'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pay' === en)) {
        const pd_0:any = ((<any>co.quickPay(false,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import50.View_QuickPayPanelComponent_0,import50.RenderType_QuickPayPanelComponent)),
    import0.ɵdid(16384,(null as any),0,import49.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(49152,(null as any),0,import51.QuickPayPanelComponent,[
      import52.PaymentModel,
      import18.SessionModel,
      import28.GroupOrderModel
    ]
    ,{
      showSpinner: [
        0,
        'showSpinner'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,{pay: 'pay'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkoutPending;
    const currVal_1:any = co.checkoutPending;
    ck(v,2,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderingPageComponent_38(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-legal-panel',[
      [
        'class',
        'desktop-page-payment-legal'
      ]
      ,
      [
        'slot',
        'sidebar-footer-end'
      ]

    ]
    ,(null as any),(null as any),(null as any),import53.View_LegalPanelComponent_0,import53.RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import54.LegalPanelComponent,[
      import20.AnalyticsService,
      import15.NavigationService
    ]
      ,{messageSet: [
        0,
        'messageSet'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'payment';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingPageComponent_26(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),59,'woa-desktop-home-page-layout',[[
        'class',
        'desktop-page'
      ]
    ],(null as any),[
      [
        (null as any),
        'onRefresh'
      ]
      ,
      [
        (null as any),
        'onSearchMenu'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onRefresh' === en)) {
        const pd_0:any = ((<any>co.requestReload('user refresh',true,true,true,true)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onSearchMenu' === en)) {
        const pd_1:any = ((<any>co.searchMenu()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import62.View_DesktopHomePageLayoutComponent_0,import62.RenderType_DesktopHomePageLayoutComponent)),
    import0.ɵdid(16384,(null as any),0,import63.BackgroundImageDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import64.CachedImageService
    ]
      ,{imageSpecs: [
        0,
        'imageSpecs'
      ]
    },(null as any)),
    import0.ɵpod(['--woa-desktop-menu-image-applied']),
    import0.ɵpod([
      'conditional',
      'on',
      'image',
      'opacity',
      'tiled',
      'classes',
      'cssVars'
    ]
    ),
    import0.ɵpod([
      'classes',
      'conditional'
    ]
    ),
    import0.ɵpad(2),
    import0.ɵdid(245760,[
      [
        3,
        4
      ]
      ,
      [
        'desktopHomePage',
        4
      ]

    ]
    ,1,import65.DesktopHomePageLayoutComponent,[
      import57.Page,
      import18.SessionModel,
      import15.NavigationService,
      import13.OrderingContextModel,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
      ,{enableNavMenuIcon: [
        0,
        'enableNavMenuIcon'
      ]
    },{
      onRefresh: 'onRefresh',
      onSearchMenu: 'onSearchMenu'
    }
    ),
    import0.ɵqud(603979776,10,{contentMessages: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import57.PageLayout,(null as any),[import65.DesktopHomePageLayoutComponent]),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingPageComponent_27)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),1,1,(null as any),View_OrderingPageComponent_28)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_OrderingPageComponent_29)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,[[
        2,
        0
      ]
    ],3,1,'woa-menu-subcategory-anchor-panel',[
      [
        'class',
        'desktop-page-menu-subcategory-anchors'
      ]
      ,
      [
        'slot',
        'content-details-header'
      ]

    ]
    ,(null as any),(null as any),(null as any),import33.View_MenuSubcategoryAnchorPanelComponent_0,import33.RenderType_MenuSubcategoryAnchorPanelComponent)),
      import0.ɵdid(4440064,[[
        'anchorPanel',
        4
      ]
    ],0,import34.MenuSubcategoryAnchorPanelComponent,[
      import32.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingPageComponent_30)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),5,1,(null as any),View_OrderingPageComponent_31)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),6,1,'woa-order-heading-panel',[
      [
        'class',
        'desktop-page-order-heading'
      ]
      ,
      [
        'slot',
        'sidebar-body'
      ]

    ]
    ,(null as any),(null as any),(null as any),import23.View_OrderHeadingPanelComponent_0,import23.RenderType_OrderHeadingPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import24.OrderHeadingPanelComponent,[
      import13.OrderingContextModel,
      import15.NavigationService
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),6,1,(null as any),View_OrderingPageComponent_32)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),6,1,'woa-order-edit-panel',[
      [
        'class',
        'desktop-page-order'
      ]
      ,
      [
        'slot',
        'sidebar-body'
      ]

    ]
    ,(null as any),[
      [
        (null as any),
        'onRetry'
      ]
      ,
      [
        (null as any),
        'onEditOrderItem'
      ]
      ,
      [
        (null as any),
        'onRemoveOrderItem'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onRetry' === en)) {
        const pd_0:any = ((<any>co.orderModel.requestOrderInitiation('ordering page - initiation error retry')) !== false);
        ad = (pd_0 && ad);
      }
      if (('onEditOrderItem' === en)) {
        const pd_1:any = ((<any>co.orderModel.editOrderItem($event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('onRemoveOrderItem' === en)) {
        const pd_2:any = ((<any>co.orderModel.removeOrderItem($event)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import39.View_OrderEditPanelComponent_0,import39.RenderType_OrderEditPanelComponent)),
    import0.ɵdid(4374528,(null as any),0,import40.OrderEditPanelComponent,[
      import13.OrderingContextModel,
      import5.OrderModel,
      import32.MenuModel,
      import15.NavigationService,
      import0.ChangeDetectorRef,
      import8.NotificationService,
      import20.AnalyticsService
    ]
    ,(null as any),{
      onRetry: 'onRetry',
      onEditOrderItem: 'onEditOrderItem',
      onRemoveOrderItem: 'onRemoveOrderItem'
    }
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),7,1,'woa-order-errors-panel',[[
        'slot',
        'footer-messages'
      ]
    ],(null as any),(null as any),(null as any),import59.View_OrderErrorsPanelComponent_0,import59.RenderType_OrderErrorsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import60.OrderErrorsPanelComponent,[
      import5.OrderModel,
      import13.OrderingContextModel,
      import18.SessionModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingPageComponent_33)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingPageComponent_34)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_OrderingPageComponent_35)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),9,1,(null as any),View_OrderingPageComponent_36)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),9,1,(null as any),View_OrderingPageComponent_37)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),10,1,(null as any),View_OrderingPageComponent_38)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,5,0,ck(v,3,0,true,!co.menuModel.showItemImages,co.menuModel.pageImage,co.menuModel.pageImageOpacity,true,'menu-page-image-color-pair',ck(v,2,0,true)),ck(v,4,0,'theme-standard-page-color-pair',false));
    ck(v,1,0,currVal_0);
    const currVal_1:any = ((co.loadingStatus === co.LoadingStatus.LOADED) || (co.loadingStatus === co.LoadingStatus.RELOADING));
    ck(v,6,0,currVal_1);
    const currVal_2:any = (co.loadingStatus === co.LoadingStatus.FAILED);
    ck(v,11,0,currVal_2);
    const currVal_3:any = co.showCarousel;
    ck(v,15,0,currVal_3);
    const currVal_4:any = co.showMenu;
    ck(v,18,0,currVal_4);
    ck(v,22,0);
    const currVal_5:any = co.showMenu;
    ck(v,25,0,currVal_5);
    const currVal_6:any = co.showOrderingContextPanel;
    ck(v,28,0,currVal_6);
    const currVal_7:any = co.showFeatureButtons;
    ck(v,34,0,currVal_7);
    ck(v,40,0);
    const currVal_8:any = co.waitTimeNotice;
    ck(v,43,0,currVal_8);
    const currVal_9:any = (co.isLoaded && co.groupOrderModel.showGroupOrderNotice);
    ck(v,46,0,currVal_9);
    const currVal_10:any = (co.isLoaded && co.orderModel.hasOrderedItems);
    ck(v,49,0,currVal_10);
    const currVal_11:any = (co.isLoaded && co.orderModel.hasOrderedItems);
    ck(v,52,0,currVal_11);
    const currVal_12:any = (((co.isLoaded && co.orderModel.hasOrderedItems) && !co.suppressQuickPay) && co.paymentModel.showQuickPay());
    ck(v,55,0,currVal_12);
    const currVal_13:any = ((co.isLoaded && co.orderModel.hasOrderedItems) && co.paymentModel.showQuickPay());
    ck(v,58,0,currVal_13);
  },(null as any));
}
export function View_OrderingPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    import0.ɵqud(671088640,1,{pageLayout: 0}),
    import0.ɵqud(671088640,2,{anchorPanelER: 0}),
    import0.ɵqud(671088640,3,{desktopHomePage: 0}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingPageComponent_26)),
    import0.ɵdid(16384,(null as any),0,import26.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import66.OrderingPageComponent = v.component;
    const currVal_0:any = co.responsiveService.mobile;
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.responsiveService.desktop;
    ck(v,7,0,currVal_1);
  },(null as any));
}
function View_OrderingPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-ordering-page',([] as any[]),(null as any),(null as any),(null as any),View_OrderingPageComponent_0,RenderType_OrderingPageComponent)),
    import0.ɵdid(245760,(null as any),0,import66.OrderingPageComponent,[
      import8.NotificationService,
      import20.AnalyticsService,
      import67.LoadingService,
      import0.ChangeDetectorRef,
      import0.ElementRef,
      import68.AuthService,
      import29.DealModel,
      import19.IdentityModel,
      import69.ActiveSchedulesSearchModel,
      import18.SessionModel,
      import13.OrderingContextModel,
      import5.OrderModel,
      import52.PaymentModel,
      import32.MenuModel,
      import70.PromoModel,
      import28.GroupOrderModel,
      import15.NavigationService,
      import14.ResponsiveService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import57.Page,(null as any),[import66.OrderingPageComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const OrderingPageComponentNgFactory:import0.ComponentFactory<import66.OrderingPageComponent> = import0.ɵccf('woa-ordering-page',import66.OrderingPageComponent,View_OrderingPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ordering-page/ordering-page.component.ngfactory.ts